module.exports = __webpack_public_path__ + "assets/img/th-b02314a7.png";